"use client";

import React from "react";
import { MapPin, Calendar, Clock, Info } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// --- EDIT YOUR SHOW SCHEDULE HERE ---
const upcomingShows = [{
  showName: "Roaring Fork Kennel Club",
  location: "Douglas County Fairgrounds and Event Center, Castle Rock, Colorado",
  status: "Confirmed",
  details: "Please come say hello after we are finished showing!",
  schedule: [{
    day: "Friday 7/10",
    time: "TBD",
    ring: "TBD",
    notes: "Sweepstakes & Specialty Classes"
  }, {
    day: "Saturday 7/11",
    time: "TBD",
    ring: "TBD",
    notes: "Regular Classes & Breed Judging"
  }, {
    day: "Sunday 7/12",
    time: "TBD",
    ring: "TBD",
    notes: "Junior Showmanship & Owner-Handled Series"
  }]
}];
// -------------------------------------

export default function ShowSchedulePage() {
  return <div className="min-h-screen bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        
        {/* Page Header */}
        <div className="text-center mb-16">
          <Badge variant="outline" className="border-purple-300 text-purple-700 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
            On The Road
          </Badge>
          <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tight text-foreground">
            Our Show Schedule
          </h1>
          <p className="mt-4 text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            We love meeting prospective families, fellow hobbyists, and breed enthusiasts. Come find us at our upcoming conformation events!
          </p>
        </div>

        {/* Schedule Cards */}
        {upcomingShows.length === 0 ? <div className="text-center py-12 border rounded-xl bg-muted/10">
            <Info className="w-10 h-10 text-muted-foreground/40 mx-auto mb-3" />
            <p className="text-muted-foreground font-medium">No public shows are scheduled at this time.</p>
          </div> : <div className="space-y-8">
            {upcomingShows.map((show, idx) => <Card key={idx} className="border border-secondary/60 shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
                <CardHeader className="bg-muted/30 border-b border-secondary/40 p-6">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                      <CardTitle className="font-serif text-2xl text-foreground mb-1">
                        {show.showName}
                      </CardTitle>
                      <div className="flex items-center text-muted-foreground gap-1.5 text-sm mt-1">
                        <MapPin className="w-4 h-4 shrink-0 text-purple-600" />
                        <span>{show.location}</span>
                      </div>
                    </div>
                    <Badge className={show.status === "Confirmed" ? "bg-green-100 text-green-800 border-green-200 self-start sm:self-center" : "bg-amber-100 text-amber-800 border-amber-200 self-start sm:self-center"}>
                      {show.status}
                    </Badge>
                  </div>
                </CardHeader>
                
                <CardContent className="p-6">
                  {show.details && <p className="text-muted-foreground text-sm font-sans mb-6 whitespace-normal leading-relaxed border-l-2 border-purple-200 pl-4 italic">
                      {show.details}
                    </p>}

                  {/* 3-Day Layout Grid */}
                  <div className="rounded-lg border bg-background overflow-hidden">
                    <div className="grid grid-cols-1 divide-y divide-border">
                      {show.schedule.map((slot, sIdx) => <div key={sIdx} className="p-4 sm:flex sm:items-center sm:justify-between gap-4 font-sans hover:bg-muted/20 transition-colors">
                          <div className="flex items-center gap-3 mb-2 sm:mb-0">
                            <div className="w-24 font-semibold text-foreground border-r pr-2 shrink-0">
                              {slot.day}
                            </div>
                            <div className="flex items-center gap-1 text-sm text-muted-foreground">
                              <Clock className="w-4 h-4 text-muted-foreground/70" />
                              <span>{slot.time}</span>
                            </div>
                          </div>
                          
                          <div className="flex items-center justify-between sm:justify-end gap-6 w-full sm:w-auto">
                            <Badge variant="secondary" className="bg-purple-50 text-purple-700 border-purple-100 font-mono font-medium">
                              {slot.ring}
                            </Badge>
                            
                          </div>
                        </div>)}
                    </div>
                  </div>

                </CardContent>
              </Card>)}
          </div>}

      </div>
    </div>;
}